import { withJsonFormsControlProps } from "@jsonforms/react";
import { useState } from "react";
import TimeframeInputField from "./TimeframeInputField";
import { deriveDisplayState, toMinutes } from "./timeframeUtils";

export const TimeframeInputComponent = (props) => {
  const { handleChange, label, data, path, errors, uischema, required, enabled } =
    props;

  const initial = deriveDisplayState(data);
  const [displayValue, setDisplayValue] = useState(initial.value);
  const [unit, setUnit] = useState(initial.unit);

  const commitChange = (newValue, newUnit) => {
    const parsed = newValue === "" ? undefined : toMinutes(newValue, newUnit);
    handleChange(path, parsed);
  };

  const handleValueChange = (newValue) => {
    const sanitized = newValue === "" ? "" : Number(newValue);
    setDisplayValue(sanitized);
    commitChange(sanitized, unit);
  };

  const handleUnitChange = (newUnit) => {
    setUnit(newUnit);
    commitChange(displayValue, newUnit);
  };

  return (
    <TimeframeInputField
      value={displayValue}
      unit={unit}
      onValueChange={handleValueChange}
      onUnitChange={handleUnitChange}
      label={uischema.showLabel === false ? "" : label}
      disabled={!enabled}
      required={required}
      errors={errors}
    />
  );
};

export const TimeframeInputControl = withJsonFormsControlProps(
  TimeframeInputComponent
);
